// extracted by mini-css-extract-plugin
module.exports = {"table-wrapper":"LowerSection_table-wrapper__3qjuY","dropdown":"LowerSection_dropdown__3A2hx","table":"LowerSection_table__1Cq44"};